<style scoped lang="scss">
    @import "../../styles/hos";
    .status {
        background: #E6F1FC;
        height: 40px;
    }
</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="['远程会诊','机构会诊申请单']"></breadcrumb>
        <div class="pt15 pl15 pr15 pb15 flex">
            <div class="flex1 pr15">
                <casultation-base-form  ref="baseForm"></casultation-base-form>
                <casultation-history-form  ref="historyForm"></casultation-history-form>
            </div>
            <div class="flex1 blshow pl15">
                <casultation-apply-form  ref="applyForm"></casultation-apply-form>
                <div class="flex jcc mt50">
                    <hos_button content="返回" @clickEvent="$router.go(-1)"></hos_button>
                    <hos_button content="确认申请" type="affirm" class="ml80" @clickEvent="doConsultationAction('提交申请',form)"></hos_button>
                </div>
            </div>
        </div>
      <!--  <div class="pl15 pr15 pb15">
            <casultation-base-form :value="form" ref="baseForm"></casultation-base-form>
            <casultation-history-form :value="form" ref="historyForm"></casultation-history-form>
            <casultation-apply-form :value="form" ref="applyForm"></casultation-apply-form>
            <div class="flex jcc">
                <el-button type="primary" size="mini" @click="doConsultationAction('提交申请',form)">提交申请
                </el-button>
            </div>
        </div>-->
    </div>
</template>

<script>
  import Breadcrumb from "../../components/common/Breadcrumb";
  import CasultationBaseForm from "../../components/consultation/base-form";
  import CasultationHistoryForm from "../../components/consultation/history-form";
  import CasultationApplyForm from "../../components/consultation/apply-form";
  import {consultationMixin} from "../../lib/mixins/consultation";
  import {isEmpty, pickByArray} from "../../lib/utils";
  import hos_button from "../../components/hos/hos-button"

  export default {
    name: "ConsultationApply",
    data() {
      return {
          form: {},
          againDetail:{}
      }
    },
    computed: {},
    components: {CasultationApplyForm, CasultationHistoryForm, CasultationBaseForm, Breadcrumb,hos_button},
    mixins: [consultationMixin],
    created() {
      const cache = this.$cache.get('consultationOrderCache');
      if (!isEmpty(cache)) {
        Log('cache', cache);
        this.form = {...pickByArray(cache, ['consulterAge'])}
      }
    },
    mounted() {
        //再次申请
        if(this.$route.query.again){
            const cache = this.$cache.get('consultationOrderCache');
            console.log('再次申请的缓存订单:')
            console.log(cache)
            this.againDetail = cache;
        }
     /* const cache = this.$cache.get('consultationOrderCache');
      if (!isEmpty(cache)) {
        this.form = {
          ...pickByArray(cache, ['consulterName', 'consulterIdcard', 'consulterInhosno', 'consulterMobile', 'maritalStatus', 'consulterJob', 'consulterAreaCode', 'consulterAddress']),
          createTime: Date.now()
        };
      }*/
    },
    methods: {}
  }
</script>
